import * as API from "./api";
import config from "../config";

const SESSION_KEY = "apit:platform-event-session";

function title(value = "") {
	return String(value)
		.replace(/[-_]+/g, " ")
		.replace(/\b\w/g, (letter) => letter.toUpperCase());
}

function sessionId() {
	let value = window.sessionStorage.getItem(SESSION_KEY);
	if (!value) {
		value = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
		window.sessionStorage.setItem(SESSION_KEY, value);
	}
	return value;
}

export function describeRoute(pathname = window.location.pathname) {
	const segments = String(pathname).split("/").filter(Boolean);
	if (!segments.length) return { module: "Home", entity: "Dashboard", labelPath: ["Home"] };
	const [root, second, third] = segments;
	const moduleNames = {
		hr: "HR", security: "Security", it: "IT", finance: "Finance", crm: "CRM",
		ecommerce: "E-Commerce", todo: "Tasks", calendar: "Calendar", database: "Projects",
		chat: "Chat", files: "Files", system: "System"
	};
	const module = moduleNames[root] || title(root);
	let labels = [module];
	let entity = second ? title(second) : "Dashboard";
	let entityId = null;

	if (root === "hr" && ["user", "user-dashboard"].includes(second)) {
		labels = ["HR", "Users", "Employee"];
		entity = "Employee";
		entityId = third || null;
	} else if (root === "hr" && second === "users") {
		labels = ["HR", "Users"];
		if (third) labels.push(title(third));
		entity = "Users";
	} else {
		segments.slice(1).forEach((segment) => {
			if (/^[a-f\d]{24}$/i.test(segment)) entityId = segment;
			else labels.push(title(segment));
		});
	}

	return { module, entity, entityId, labelPath: labels };
}

export function newEventId() {
	return window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

export function recordEvent(payload) {
	return API.post(config.api.system.events, {
		clientSessionId: sessionId(),
		...payload
	});
}

export function finalizeEvent(eventId, payload) {
	return API.patch(`${config.api.system.events}/${encodeURIComponent(eventId)}`, payload);
}

export function getClientSessionId() {
	return sessionId();
}
